import React from 'react';
import { Link } from 'react-router-dom';

function HouseQuoteInfo({ houseQuote, setShowGreeniaAI }) {
  return (
    <div className="w-75 ms-auto mb-3">
      <div className="bg-success border border-success p-3 rounded-3 shadow">
        <h5 className="fs-6 text-white">Nuovo Preventivo Casa</h5>
        <hr />
        <div>
          <div>
            <div className="row">
              <div className="col-12">
                <p className="m-0 text-white">
                  <small>
                    <strong>
                      Premio Totale:
                    </strong>
                    {' '}
                    {parseFloat(houseQuote?.quote?.total).toFixed(2)}
                    {' '}
                    €
                  </small>
                </p>
              </div>
              {/* <div className="col-12">
                <p className="m-0 text-white">
                  <small>
                    <strong>
                      Province:
                    </strong>
                    {' '}
                    {houseQuote?.quote?.province}

                  </small>
                </p>
              </div> */}
              {/* <div className="col-12">
                <p className="m-0 text-white">
                  <small>
                    <strong>
                      Commune:
                    </strong>
                    {' '}
                    {houseQuote?.quote?.commune}

                  </small>
                </p>
              </div> */}
              <div className="col-12">
                <p className="m-0 text-white">
                  <small>
                    <strong>
                      Valore Fabbricato:
                    </strong>
                    {' '}
                    {Number(houseQuote?.quote?.building_value).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    {' '}
                    €
                  </small>
                </p>
              </div>

              {/* {houseQuote?.quote?.quotes?.map((quote, index) => (
                <div className="col-12" key={index}>
                  <p className="m-0 text-white">
                    <small>
                      <strong>
                        {quote?.name}
                        :
                      </strong>
                      {' '}
                      {quote?.price}
                      {' '}
                      €
                    </small>
                  </p>
                </div>

              ))} */}

            </div>
            <hr />
            <div className="row mt-2">
              <div className="col-12">
                <Link
                  onClick={() => setShowGreeniaAI(false)}
                  className="btn btn-light"
                  to={`/quote/casa/${houseQuote?.fastQuoteId}`}
                >
                  Procedi con il Preventivo
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HouseQuoteInfo;
